export default __webpack_public_path__ + "static/media/bg.9eba1a64.png";